import { Typography, Box } from "@mui/material" 
import FormDescription from "../../../../inputFormComponents/FormDescription"
import image from './../../../../resources/InvoiceAdress.png'

const DescriptionInvoiceAdress = () => {
  return (
    <FormDescription 
      paragraphs={[
        <Box key={1}>
          <Typography variant="body1">Rechnungsadresse:</Typography>
          <Typography variant="body2">Hier wählst du deinen Kunden mit entsprechend vorkonfigurierten Textbausteinen aus. Solltest du den Kunden noch nicht angelegt haben, wird dieser automatisch in die Kundenverwaltung übernommen.</Typography>
        </Box>
      ]}
      image={image}
    />
  )
}

export default DescriptionInvoiceAdress